module.exports = __webpack_public_path__ + "img/ventas_mobile.3e808efe.svg";